import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";

const Program = () => {
  return (
    <React.Fragment>
      <SEO title="Program | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Program"
        content="The Conference"
        contentTwo="Program"
        linkage="/"
      />

      <EmptyTwo>
        <div className="entry-content title-center">
          <h2>ICSI&apos;2026 Program</h2>
          <p>
            The conference program is being updated. Please check back later for
            the latest schedule and handbook.
          </p>
        </div>
      </EmptyTwo>

      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Program;
